import { PrimaryButton } from "@components/Buttons/PrimaryButton";
import { BaseModalComponent } from "@components/common/BaseModalComponent";
import { FlowMobilePlanConfig } from "@components/virtual-receptionist/widget";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Box, Chip, Typography } from "@mui/material";
import { CompanyNumber } from "..";
import { SetupNumber } from "../../SetupNumber";
import { AssignExistingNumber } from "./AssignExistingNumber";

const pendingChipSx = {
  height: 24,
  borderRadius: "999px",
  bgcolor: "rgba(251,142,0,0.08)",
  border: "1px solid rgba(251,142,0,0.18)",
  color: "#FB8E00",
  fontSize: 12,
  fontWeight: 800,
  "& .MuiChip-icon": {
    color: "#FB8E00",
  },
};

interface PendingNumberBlockProps {
  plan: FlowMobilePlanConfig;
  plans: FlowMobilePlanConfig[];
  availableNumbers?: CompanyNumber[];
}

export function PendingNumberBlock({ plan, plans, availableNumbers = [] }: PendingNumberBlockProps) {
  const hasAvailableNumbers = availableNumbers.length > 0;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        alignItems: "center",
        columnGap: 1.5,
        flexShrink: 0,
      }}
    >
      <Box sx={{ minWidth: 0, mr: 2 }}>
        <Typography
          sx={{
            mt: 0.8,
            fontSize: 14,
            fontWeight: 700,
            color: "var(--fx-surface-textsecondary, #64748B)",
            lineHeight: 1.1,
          }}
        >
          Not assigned yet
        </Typography>

        <Box sx={{ mt: 0.8 }}>
          <Chip size="small" icon={<WarningAmberOutlinedIcon sx={{ fontSize: "14px !important" }} />} label="Setup required" sx={pendingChipSx} />
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        {hasAvailableNumbers && (
          <BaseModalComponent
            modalKey={`Dashboard-Assign-${plan.subscriptionId}`}
            modalLabel={`Assign number`}
            defaultSizes={{
              width: 500,
              height: "auto",
            }}
            elementTrigger={
              <PrimaryButton
                variant="outlined"
                sx={{
                  borderRadius: "8px",
                  px: 2,
                  whiteSpace: "nowrap",
                  py: 0.9,
                  fontWeight: 800,
                }}
              >
                Assign number
              </PrimaryButton>
            }
          >
            <AssignExistingNumber key={`assign-${plan.subscriptionId}`} plan={plan} plans={plans} availableNumbers={availableNumbers} />
          </BaseModalComponent>
        )}

        <BaseModalComponent
          modalKey={`Dashboard-Setup-${plan.subscriptionId}`}
          modalLabel={`Set up ${plan.name}`}
          elementTrigger={
            <PrimaryButton
              sx={{
                borderRadius: "8px",
                px: 2,
                whiteSpace: "nowrap",
                py: 0.9,
                fontWeight: 800,
              }}
            >
              Set up new
            </PrimaryButton>
          }
        >
          <SetupNumber key={plan.subscriptionId} plan={plan} />
        </BaseModalComponent>
      </Box>
    </Box>
  );
}
